/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import Select from 'react-select'
import {Link, withRouter} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'

class CompleteProductDriversDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      list: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد محصول',
          value: 'productCode',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نیاز راننده',
          value: 'quantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد در پیش سند',
          value: 'docQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'موجودی انبار',
          value: 'remainQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'امکان تحویل',
          value: 'remainQuantity',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      Drivers: [],
      driverId: ''
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  get componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    this.getReport(false)
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    let {id, planDateMin, planDateMax, name} = this.props.match.params

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_DETAILS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            errorForm: '',
            lengthList: response.data.object.countAll,
            printFrom: this.state.planDateMin == '' ? ' - ' : jMoment(this.state.planDateMin).format('jYY/jMM/jDD'),
            printTo: this.state.planDateMax == '' ? ' - ' : jMoment(this.state.planDateMax).format('jYY/jMM/jDD'),
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let {id, planDateMin, planDateMax, name} = this.props.match.params

    let driverId = id

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (driverId !== '') {
      filter.driverId = driverId
    }

    if (planDateMin !== '') {
      filter.planDateMin = planDateMin
    }
    if (planDateMax !== '') {
      filter.planDateMax = planDateMax
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.getReport(false)
    }
  }

  changeDropDown(data) {
    this.setState({
      listWareHouse: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_DETAILS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_DETAILS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        }
      })
  }

  render() {
    let {pageNumber, pageSize} = this.state
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'نام محصول',
      'کد محصول',
      'تامین کننده',
      'نیاز راننده',
      'تعداد در پیش سند',
      'موجودی انبار',
      'امکان تحویل'
    ]
    let driverName = this.props.match.params.name

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={'جزییات کالاهای دریافت شده رساننده :‌ ' + driverName}
              headerColSpan={8}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={3}
              centerColSpan={2}
              centerSection={''}
              rightSection={'تاریخ از ' + this.state.printFrom + ' تا ' + this.state.printTo}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td>{item.productCode}</td>
                  <td>{item.providerName}</td>
                  <td>{item.quantity}</td>
                  <td>{item.docQuantity}</td>
                  <td>{item.remainQuantity}</td>
                  <td>
                    {item.received ? (
                      <img style={{width: '20px'}} src={require('../../image/confirm.svg')} />
                    ) : (
                      <img style={{width: '20px'}} src={require('../../image/ignor.svg')} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName={'جزییات کالاهای دریافت شده رساننده :‌ ' + driverName + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'quantity'}
                field={'quantity'}
                title={'نیاز راننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'docQuantity'}
                field={'docQuantity'}
                title={'تعداد در پیش سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'remainQuantity'}
                field={'remainQuantity'}
                title={'موجودی انبار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'received'}
                field={'received'}
                title={'امکان تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>کالاهای تکمیل شده رانندگان</li>
            <li> {driverName}کالاهای تکمیل شده </li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.productName}</td>
                      <td>{item.productCode}</td>
                      <td>{item.providerName}</td>
                      <td>{item.quantity}</td>
                      <td>{item.docQuantity}</td>
                      <td>{item.remainQuantity}</td>
                      <td>
                        {item.received ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CompleteProductDriversDetails)
